import React from "react";
import { Divider } from "antd";
import { formatToCurrencyWithScale} from "../../../helpers/FormatHelper";
import { useEffect, useState} from "react";
import LoadingBox from "../../shared/LoadingBox";
import AlertBox from "../../shared/AlertBox";
import { save } from "./TicketService";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { reverseTicket } from "../../../networking/NetworkingTicket";

export function TicketSummary({objTicket, ticketType,  backScreen, cancelTicket, customerID, contactID, customerName, contactName, newTicket, balances}){
   
        const userID=localStorage.getItem('UserID');
        const [ticketNo, setTicketNo] = useState(0);
        const [loading, setLoading] = useState(false);
        const [alertTitle, setAlertTitle] = useState('');
        const [alertMessage, setAlertMessage] = useState('');
        const [showAlert, setShowAlert] = useState(false);
        const [saved, setSaved] = useState(false);
        const [showBookConfirmation, setShowBookConfirmation] = useState(false);
        const [showReverseDialog, setShowReverseDialog] = useState(false);
        const [commentReverse, setCommentReverse] = useState('');


    useEffect(() => {
        if (objTicket?.TicketNo > 0) {
            setTicketNo(objTicket.TicketNo);
        }
    }, [objTicket?.TicketNo]);


    const getRowsIncoming=()=>{
        const rows = [];

        if(objTicket.TicketRows)
        {
            objTicket.TicketRows.forEach((o, index) =>{
                rows.push(<div id={`ticketsummary4-${index}`} key ={`ticketsummary4-${index}`} className="uk-grid margin-left-detail-summary-items">

                <div id={`ticketsummary41-${index}`} key ={`ticketsummary41-${index}`} className="uk-width-1-4 summary-row">{o.CurrencyName}</div>
                <div id={`ticketsummary42-${index}`} key ={`ticketsummary42-${index}`} className="uk-width-1-8 summary-row uk-amount">{formatToCurrencyWithScale(o.Amount,o.CurrencyScale)}</div>
                <div id={`ticketsummary43-${index}`} key ={`ticketsummary43-${index}`} className="uk-width-1-4 summary-row">{o.Instrument}</div>
                <div id={`ticketsummary44-${index}`} key ={`ticketsummary44-${index}`} className="uk-width-1-4 summary-row">{o.DeliveryMethod}</div>
               

            </div>)

            })
        }
        return rows;
    }

    
    const getRowsOutgoing=()=>{
        const rows = [];

        if(objTicket.TicketRows)
        {
            objTicket.TicketRows.forEach((o, index) =>{
                rows.push(<div id={`ticketsummary4-${index}`} key ={`ticketsummary4-${index}`} className="uk-grid margin-left-detail-summary-items">

                <div id={`ticketsummary42-${index}`} key ={`ticketsummary42-${index}`} className="uk-width-1-4 summary-row">{o.RecipientName}</div>
                
                <div id={`ticketsummary43-${index}`} key ={`ticketsummary43-${index}`} className="uk-width-1-4 summary-row">{o.CurrencyName}</div>
                <div id={`ticketsummary44-${index}`} key ={`ticketsummary44-${index}`} className="uk-width-1-8 summary-row uk-amount">{formatToCurrencyWithScale(o.Amount,o.CurrencyScale)}</div>                
                <div id={`ticketsummary45-${index}`} key ={`ticketsummary45-${index}`} className="uk-width-1-4 summary-row">{isNaN(o.Instrument) ? o.Instrument: o.BankAccountName}</div>
                <div id={`ticketsummary46-${index}`} key ={`ticketsummary46-${index}`} className="uk-width-1-8 summary-row">{o.DeliveryMethod}</div>
               
                
            </div>)

            })
        }
        return rows;
    }

    const saveTicket = async() =>{

        setLoading(true);
        const responseSave = await save(objTicket,objTicket.Comments, customerID, userID, ticketType, contactID, balances);
        setLoading(false);    

        if(responseSave && responseSave.Success)
        {
            objTicket.Status = "";


           /* if(ticketNo === 0)
            {
                getTicketUpdated(responseSave.TicketNo);
            }
            */
            //setTicketNo(objTicket.TicketNo > 0? objTicket.TicketNo:responseSave.TicketNo);
            setSaved(true);
        }

        setAlertTitle(responseSave.Title);
        setAlertMessage(responseSave.Message);
        setShowAlert(true);
        
    }



      const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };

    const bookTicket = async() => {
        setShowBookConfirmation(true);
    }

    const yesBookConfirmation = async() => {
        setShowBookConfirmation(false);
        saveTicket();
    }
    
     const closeBookConfirmation =() =>{
        setShowBookConfirmation(false);
    }

    const onBack = ()=>{
        backScreen({
                    ...objTicket,
                    TicketRows: [...objTicket.TicketRows]
                }, (objTicket?.TicketNo === null || objTicket?.TicketNo === undefined || objTicket?.TicketNo === 0 ))
        }

    const getRows = () =>{
        return ticketType === 'Incoming' ? getRowsIncoming(): getRowsOutgoing();
    }

    const saveReverse = async () => {
        setLoading(true);
        const responseSave = await reverseTicket(objTicket.TicketNo, commentReverse, userID);
        setLoading(false);    

        setAlertTitle(responseSave.Title);
        setAlertMessage(responseSave.Message);
        setShowAlert(true);
        cancelTicket();
    }


    return <div id={'ticketsummary1'} key ={'ticketsummary1'}>
        {ticketNo > 0 && <div id={'ticketsummary11'} key ={'ticketsummary11'} className="uk-grid margin-left-detail-summary">
           <div id={'ticketsummary11'} key ={'ticketsummary11'} className="uk-width-2-12 summary-tickettitle" style={{paddingLeft:'0px'}}>
            {`Ticket No: ${ticketNo}`}
            </div>
          
        </div>}
            <div id={'ticketsummary2'} key ={'ticketsummary2'} className='uk-grid margin-left-detail-summary'>
               
                    <div id={'ticketsummary211'} key ={'ticketsummary211'} className="uk-width-1-1 summary-subtitle">{`Customer`}</div>

                    <div id={'ticketsummary2111'} key ={'ticketsummary2111'} className="uk-width-1-6">{`Account Number: `}</div>
                    <div id={'ticketsummary2112'} key ={'ticketsummary2112'} className="uk-width-5-6" >{customerID}</div>
                    <div id={'ticketsummary2113'} key ={'ticketsummary2113'} className="uk-width-1-6">{`Name: `}</div>
                    <div id={'ticketsummary2114'} key ={'ticketsummary2114'} className="uk-width-5-6" >{customerName}</div>
                    <div id={'ticketsummary2117'} key ={'ticketsummary2117'} className="uk-width-1-6">{`Contact: `}</div>
                    <div id={'ticketsummary2118'} key ={'ticketsummary2118'} className="uk-width-5-6" >{contactName}</div>
     
            </div>
            
            <div  id={'ticketsummary3'} key ={'ticketsummary3'} className="uk-grid margin-left-detail-summary">

                <div id={'ticketsummary31'} key ={'ticketsummary31'} className="uk-width-1-1 summary-subtitle">{ticketType}</div>

                { ticketType !== 'Incoming' &&
                    <div id={'ticketsummary314'} key ={'ticketsummary314'} className="uk-width-1-4 bold-text ticket-row-title">{'Recipient'}</div>
                }

               
                <div id={'ticketsummary310'} key ={'ticketsummary310'} className="uk-width-1-4 bold-text ticket-row-title">{'Currency'}</div>
                <div id={'ticketsummary311'} key ={'ticketsummary311'} className="uk-width-1-8 bold-text ticket-row-title-number">{'Amount'}</div>
               
                <div id={'ticketsummary312'} key ={'ticketsummary312'} className={`uk-width-1-4 bold-text ticket-row-title`}>{'Intrument'}</div>
                
                <div id={'ticketsummary313'} key ={'ticketsummary313'} className={`uk-width-1-${ticketType !== 'Incoming' ? 8:4} bold-text ticket-row-title`}>{'Delivery Method'}</div>

            </div>
            {getRows()}         
            

            <div id={'ticketsummary20'} key={'ticketsummary20'} className="uk-grid margin-left-detail-summary">
                <div id={'ticketsummary201'} key ={'ticketsummary201'} className="uk-width-1-1 summary-subtitle">{'Comments'}</div>
            </div>

            {!saved  && 
            <div id={'ticketsummary202'} key ={'ticketsummary202'} className="uk-grid margin-left-detail-summary">
                <textarea id={'ticketsummaryComments'} key={'ticketsummaryComments'} className='uk-textarea' value={objTicket.Comments} disabled={true} /> 
            </div>
            }

            <div id={'ticketsummary10'} key={'ticketsummary10'} className="uk-grid margin-left-detail-summary">
                <div id={'ticketsummary101'} key ={'ticketsummary101'} className="uk-width-1-1 summary-subtitle">{`Delivery to / Pick Up from`}</div>
            </div>            

            <div id={'ticketsummary131'} key={'ticketsummary131'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                <div id={'ticketsummary1311'} key ={'ticketsummary131'} className="uk-width-1-6">{'Date:'}</div>
                <div id={'ticketsummary1321'} key ={'ticketsummary132'} className="uk-width-5-6">{`${new Date(objTicket.DeliveryDate).toDateString()}`}</div>
            </div>

            {objTicket.Status === 'Reversed' && 

            <>
                <div id={'ticketsummary25'} key={'ticketsummary25'} className="uk-grid margin-left-detail-summary">
                    <div id={'ticketsummary251'} key ={'ticketsummary251'} className="uk-width-1-1 summary-subtitle">{'Reverse Info'}</div>
                </div>
                <div id={'ticketsummary252'} key ={'ticketsummary252'} className="uk-grid margin-left-detail-summary">
                    <textarea id={'ticketsummaryComments'} key={'ticketsummaryComments'} className='uk-textarea' value={objTicket.ReverseComments} disabled={true} /> 
                </div>
                <div id={'ticketsummary251'} key={'ticketsummary251'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                    <div id={'ticketsummary2511'} key ={'ticketsummary2511'} className="uk-width-1-6">{'Date:'}</div>
                    <div id={'ticketsummary2521'} key ={'ticketsummary2521'} className="uk-width-5-6">{`${new Date(objTicket.ReverseDate).toDateString()}`}</div>
                </div>
                <div id={'ticketsummary253'} key={'ticketsummary253'} className="uk-grid margin-left-detail-summary" style={{marginTop:'0px'}}>
                    <div id={'ticketsummary2531'} key ={'ticketsummary2531'} className="uk-width-1-6">{'Reversed By:'}</div>
                    <div id={'ticketsummary2532'} key ={'ticketsummary2532'} className="uk-width-5-6">{`${objTicket.ReverseUserName}`}</div>
                </div>
            </>
            
            }



            <Divider/>
            <div className="margin-left-detail-summary" style={{ marginTop: '20px', marginBottom: '20px', padding: 0, textAlign:'end' }}>
                {objTicket.Status === 'Accepted' &&
                <button className="uk-button uk-button-green" onClick={() => setShowReverseDialog(true)}>
                    {'Reverse'}
                </button>}
                {saved &&  objTicket.TicketNo > 0 &&
                <button className="uk-button uk-button-green" onClick={() => newTicket(customerID, contactID, customerName)}>
                    {'New Ticket'}
                </button>}

                {!saved && (objTicket.TicketNo === undefined || objTicket.TicketNo === 0) &&
                <button className="uk-button uk-button-green" onClick={onBack}>
                    {'Back'}
                </button>
                }
                {!saved && (objTicket.TicketNo === undefined || objTicket.TicketNo === 0) &&
                <button className="uk-button uk-button-green" onClick={saveTicket/*bookTicket*/} >
                    {'Book'}
                </button>
                }
                <button className="uk-button uk-button-green" onClick={cancelTicket}>
                    {'Exit'}
                </button>
            </div>

            <Dialog open={showReverseDialog} onClose={() => setShowReverseDialog(false)}>
                <DialogTitle>{'Reverse Ticket'}</DialogTitle>
                <DialogContent>
                    <div >
                        <label className="uk-form-label" htmlFor="form-bank-status">Add Comment for ticket {objTicket.TicketNo} :</label>
                        <textarea className="uk-textarea" style={{marginTop: "5px"}} id="dealComment" type="text" placeholder="" value={commentReverse} onChange={(e)=>setCommentReverse(e.target.value)}></textarea>
                    </div>                
                </DialogContent>
                <DialogActions>
                    <button className="uk-button uk-button-green" key={"save"} disabled={!commentReverse || commentReverse.length === 0} type="button" onClick={saveReverse}>Save</button>
                    <button className="uk-button uk-button-green" key={"cancel"} type="button" onClick={() => setShowReverseDialog(false)}>Close</button>
                </DialogActions>
            </Dialog>

            <LoadingBox loading={loading}/>
            <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />

            <AlertBox open={showBookConfirmation} title={'Book Confirmation'}
                            message="Are you sure you want to book this ticket?"
                            type="Yes/No"
                            onClose={closeBookConfirmation}
                            yesClick={yesBookConfirmation}
                            noClick={closeBookConfirmation}/>
        </div>
}

export default TicketSummary